import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dashboard_mobile_push_ios",
  "use": "dashboard_mobile_push_ios-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"dashboard_mobile_push_ios\"><path d=\"M17 19v8.357A3.643 3.643 0 0113.357 31H4.644A3.644 3.644 0 011 27.357V6.644A3.645 3.645 0 014.644 3H8M1 25h16\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M27 1H16a4 4 0 00-4 4v6a4 4 0 004 4h5v5l5-5h1a4 4 0 004-4V5a4 4 0 00-4-4z\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M16.5 7.5a.5.5 0 100 1 .5.5 0 000-1M21.5 7.5a.5.5 0 100 1 .5.5 0 000-1M26.5 7.5a.5.5 0 100 1 .5.5 0 000-1\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/dashboard_mobile_push_ios.svg
// module id = 5/+5
// module chunks = 39 44